import $ from 'jquery';

const root = document.querySelector('[data-product-sets]');

if (root) {
    const panel = root.querySelector('[data-set-panel]');
    const panelTitle = root.querySelector('[data-set-panel-title]');
    const close = root.querySelector('[data-set-close]');
    const content = root.querySelector('[data-set-content]');
    const feedback = root.querySelector('[data-set-feedback]');
    const retry = root.querySelector('[data-set-retry]');
    const buttons = Array.from(root.querySelectorAll('[data-set-choice]'));
    const nativeForm = document.querySelector('form.variations_form');
    const saved = new Map();
    let config = null;
    let request = null;
    let busy = false;
    let syncing = false;
    let controlsLocked = false;
    let needsRefresh = false;
    let uncertain = false;
    let guided = false;
    let selection = [];
    let pendingPayload = null;
    let activeId = null;
    let expanded = false;
    let formatter;
    let dockFrame = null;

    const announce = (message = '', error = false) => {
        feedback.textContent = message;
        feedback.dataset.error = String(error);
    };
    const money = (amount) => formatter.format(amount / 10 ** config.decimals);
    const matches = (variant, attributes) =>
        Object.entries(attributes).every(([key, value]) => !value || !variant.attributes[key] || variant.attributes[key] === value);
    const setText = (selector, value) => content.querySelectorAll(selector).forEach((element) => { element.textContent = value; });
    const controls = (disabled) => {
        controlsLocked = disabled;
        close.disabled = disabled;
        buttons.forEach((button) => { button.disabled = disabled; });
        content.querySelectorAll('select, [data-set-pill], [data-set-jump], [data-set-expand-options]').forEach((control) => {
            control.disabled = disabled || control.dataset.unavailable === 'true';
        });
    };
    const scrollTo = (element) => element.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });

    const updateDock = () => {
        dockFrame = null;
        const dock = content.querySelector('[data-set-dock]');
        if (!dock) return;
        if (!expanded || !config) { dock.hidden = true; return; }
        const section = root.getBoundingClientRect();
        const action = content.querySelector('.ProductSets__summary [data-set-submit]').getBoundingClientRect();
        const actionVisible = action.top > 120 && action.bottom < window.innerHeight;
        dock.hidden = !config || !window.matchMedia('(max-width: 767px)').matches || section.top > 120 || section.bottom < 180 || actionVisible;
    };
    const queueDock = () => { if (dockFrame === null) dockFrame = window.requestAnimationFrame(updateDock); };
    window.addEventListener('scroll', queueDock, { passive: true });
    window.addEventListener('resize', queueDock, { passive: true });

    const setExpanded = (value) => {
        expanded = value;
        panel.hidden = !value;
        buttons.forEach((button) => {
            const open = value && button.dataset.setChoice === activeId;
            button.setAttribute('aria-expanded', String(open));
            button.querySelector('[data-set-choice-label]').textContent = open ? 'Zwiń wybór' : 'Wybierz zestaw';
        });
        if (!value) content.querySelector('[data-set-dock]')?.setAttribute('hidden', '');
        queueDock();
    };

    const collapse = () => {
        if (controlsLocked || busy || uncertain) return;
        setExpanded(false);
        announce();
        const choice = buttons.find((button) => button.dataset.setChoice === activeId);
        choice?.focus({ preventScroll: true });
        choice?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };

    // Keep native selects as the source of truth, and use direct choices for short option lists.
    const enhanceOptions = () => {
        content.querySelectorAll('[data-attribute]').forEach((select) => {
            const options = Array.from(select.options).filter((option) => option.value);
            const visual = select.dataset.visual === 'true';
            if (options.length > 8 && !visual) return;
            const group = document.createElement('div');
            group.className = 'ProductSets__pills' + (visual ? ' ProductSets__pills--visual' : '');
            group.id = `${select.id}-options`;
            if (visual) group.dataset.expanded = String(options.length <= 6);
            group.setAttribute('role', 'group');
            group.setAttribute('aria-labelledby', select.getAttribute('aria-labelledby'));
            group.setAttribute('aria-describedby', select.closest('[data-set-product]').querySelector('[data-set-availability]').id);
            options.forEach((option) => {
                const button = document.createElement('button');
                button.type = 'button';
                button.className = 'Button--no-style ProductSets__pill';
                button.dataset.setPill = String(option.index);
                button.setAttribute('aria-pressed', 'false');
                const label = document.createElement('span');
                label.textContent = option.textContent;
                if (visual) {
                    button.classList.add('ProductSets__pill--image');
                    if (option.dataset.image) {
                        const image = document.createElement('img');
                        image.src = option.dataset.image;
                        image.alt = '';
                        image.loading = 'lazy';
                        button.append(image);
                    }
                } else if (/^#[\da-f]{3}([\da-f]{3})?$/i.test(option.dataset.swatch || '')) {
                    button.classList.add('ProductSets__pill--color');
                    const swatch = document.createElement('span');
                    swatch.className = 'ProductSets__swatch';
                    swatch.style.setProperty('--swatch', option.dataset.swatch);
                    swatch.setAttribute('aria-hidden', 'true');
                    button.append(swatch);
                }
                button.append(label);
                group.append(button);
            });
            select.hidden = true;
            select.after(group);
            if (visual && options.length > 6) {
                const expand = document.createElement('button');
                expand.type = 'button';
                expand.className = 'Button--no-style ProductSets__expandOptions';
                expand.dataset.setExpandOptions = String(options.length);
                expand.textContent = `Pokaż wszystkie warianty (${options.length})`;
                expand.setAttribute('aria-expanded', 'false');
                expand.setAttribute('aria-controls', group.id);
                group.after(expand);
            }
        });
    };

    const update = () => {
        if (!config) return;
        let total = 0;
        let normal = 0;
        let missing = 0;
        let unavailable = false;
        selection = [];
        config.items.forEach((item, index) => {
            const card = content.querySelector(`[data-set-product="${item.id}"]`);
            const selects = Array.from(card.querySelectorAll('select'));
            const attributes = {};
            const labels = [];
            const missingLabels = [];
            selects.forEach((select) => {
                const options = Array.from(select.options).filter((option) => option.value !== '');
                options.forEach((option) => {
                    option.disabled = !item.variants.some((variant) => variant.available && matches(variant, { ...attributes, [select.dataset.attribute]: option.value }));
                });
                if (select.selectedOptions[0]?.disabled) select.value = '';
                const available = options.filter((option) => !option.disabled);
                if (!select.value && available.length === 1) select.value = available[0].value;
                if (select.value) {
                    attributes[select.dataset.attribute] = select.value;
                    labels.push(select.selectedOptions[0].textContent);
                } else {
                    missingLabels.push(item.attributes.find((attribute) => attribute.name === select.dataset.attribute).label.toLocaleLowerCase('pl'));
                }
                const field = select.closest('[data-set-option]');
                field.dataset.invalid = String(guided && !select.value);
                select.setAttribute('aria-invalid', String(guided && !select.value));
                field.querySelector('[data-set-option-value]').textContent = select.value ? select.selectedOptions[0].textContent : '';
                const collapsed = field.querySelector('.ProductSets__pills--visual')?.dataset.expanded === 'false';
                const previewValues = (available.length ? available : options).slice(0, 6).map((option) => option.value);
                if (select.value && !previewValues.includes(select.value)) previewValues.splice(5, 1, select.value);
                field.querySelectorAll('[data-set-pill]').forEach((button) => {
                    const option = select.options[Number(button.dataset.setPill)];
                    button.hidden = collapsed && !previewValues.includes(option.value);
                    button.disabled = controlsLocked || option.disabled;
                    button.dataset.unavailable = String(option.disabled);
                    button.setAttribute('aria-pressed', String(option.value === select.value));
                    button.setAttribute('aria-label', option.textContent + (option.disabled ? ' — niedostępny dla tego wyboru' : ''));
                    button.title = option.textContent + (option.disabled ? ' — niedostępny dla tego wyboru' : '');
                });
            });
            saved.set(item.id, attributes);
            const candidates = item.variants.filter((variant) => variant.available && matches(variant, attributes));
            const complete = selects.length === Object.keys(attributes).length;
            const chosen = complete ? candidates[0] : null;
            const preview = chosen || candidates.reduce((cheapest, variant) => !cheapest || variant.amount < cheapest.amount ? variant : cheapest, null);
            const status = card.querySelector('[data-set-availability]');
            const price = card.querySelector('[data-set-item-price]');
            card.dataset.complete = String(!!chosen);
            card.dataset.guided = String(guided && !chosen);
            card.querySelector('[data-set-item-status]').textContent = chosen ? 'Gotowe' : preview ? 'Wybierz wariant' : 'Niedostępny';
            if (!preview) {
                unavailable = true;
                price.textContent = 'Obecnie niedostępny';
            } else {
                total += preview.amount;
                normal += preview.normal;
                price.textContent = (chosen ? '' : 'od ') + money(preview.amount);
                if (chosen && preview.normal > preview.amount) {
                    const original = document.createElement('del');
                    original.textContent = money(preview.normal);
                    price.append(original);
                }
                const imageSlot = card.querySelector('[data-set-image]');
                if (imageSlot.dataset.variant !== String(preview.id)) {
                    imageSlot.innerHTML = preview.image;
                    imageSlot.dataset.variant = String(preview.id);
                    delete imageSlot.dataset.fallback;
                }
            }
            if (!chosen) missing++;
            status.textContent = chosen ? (chosen.stock_note || 'Gotowe do zestawu') : (preview ? `Wybierz: ${missingLabels.join(' i ')}` : 'Ten produkt jest obecnie niedostępny');
            status.hidden = chosen ? !chosen.stock_note : !!preview && !guided;
            const review = content.querySelector(`[data-set-jump="${item.id}"]`);
            review.dataset.complete = String(!!chosen);
            review.querySelector('[data-set-review-number]').textContent = chosen ? '✓' : String(index + 1);
            review.querySelector('[data-set-review-value]').textContent = chosen ? (labels.join(' · ') || '1 sztuka') : (preview ? `Wybierz: ${missingLabels.join(' i ')}` : 'Niedostępny');
            if (chosen) selection.push({ product_id: item.id, variation_id: chosen.id, attributes, token: chosen.token });
        });
        const ready = config.items.length - missing;
        setText('[data-set-total]', unavailable ? '—' : money(total));
        setText('[data-set-total-label]', missing ? 'Cena zestawu od' : 'Cena całego zestawu');
        setText('[data-set-progress]', missing ? `Wybrane warianty: ${ready} z ${config.items.length}` : 'Twój zestaw jest gotowy');
        setText('[data-set-dock-progress]', `${ready} z ${config.items.length} wybranych`);
        content.querySelector('[data-set-progress-bar]').value = ready;
        content.querySelector('[data-set-estimate]').hidden = !missing || unavailable;
        const original = content.querySelector('[data-set-original]');
        original.hidden = !!missing || unavailable || normal <= total;
        const originalPrice = document.createElement('del');
        originalPrice.textContent = money(normal);
        original.replaceChildren('Kupowane osobno: ', originalPrice);
        const saving = content.querySelector('[data-set-saving]');
        saving.hidden = !!missing || unavailable || normal <= total;
        saving.textContent = `Oszczędzasz ${money(normal - total)}`;
        content.querySelectorAll('[data-set-submit]').forEach((submit) => {
            submit.disabled = busy || unavailable || needsRefresh;
            submit.setAttribute('aria-busy', String(busy));
            submit.dataset.ready = String(!missing && !unavailable);
        });
        setText('[data-set-submit-label]', busy ? 'Dodajemy zestaw…' : needsRefresh ? 'Odśwież zestaw poniżej' : uncertain ? 'Sprawdź dodanie' : unavailable ? 'Zestaw niedostępny' : missing ? 'Wybierz warianty' : 'Dodaj cały zestaw');
        setText('[data-set-hint]', unavailable
            ? 'Wybierz inne połączenie lub sprawdź dostępność później.'
            : '');
        queueDock();
    };

    const nativeSelection = () => {
        const values = {};
        if (nativeForm) nativeForm.querySelectorAll('select[name^="attribute_"]').forEach((select) => { values[select.name] = select.value; });
        return values;
    };

    const load = (id) => {
        if (!id || busy || uncertain) return;
        if (request) request.abort();
        activeId = id;
        config = null;
        pendingPayload = null;
        needsRefresh = false;
        guided = false;
        panelTitle.textContent = buttons.find((button) => button.dataset.setChoice === id).querySelector('.ProductSets__choiceName').textContent;
        setExpanded(true);
        controls(true);
        content.querySelectorAll('[data-set-submit]').forEach((button) => { button.disabled = true; });
        content.querySelector('[data-set-dock]')?.setAttribute('hidden', '');
        root.setAttribute('aria-busy', 'true');
        announce('Wczytujemy aktualne ceny i warianty…');
        retry.hidden = true;
        const current = $.ajax({
            url: root.dataset.endpoint, method: 'GET', dataType: 'json', cache: false, timeout: 20000,
            data: { action: 'ravessa_product_set', product_id: root.dataset.productId, set_id: id },
        });
        request = current;
        const fail = (message) => {
            content.innerHTML = '';
            announce(message || 'Nie udało się wczytać zestawu. Spróbuj ponownie.', true);
            retry.hidden = false;
        };
        current.done((response) => {
            if (request !== current) return;
            if (!response.success || !response.data?.html) { fail(response.data?.message); return; }
            config = response.data;
            formatter = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: config.currency, minimumFractionDigits: config.decimals, maximumFractionDigits: config.decimals });
            content.innerHTML = config.html;
            config.items.forEach((item) => {
                const values = item.id === config.base_id && nativeForm ? nativeSelection() : (saved.get(item.id) || item.selected);
                content.querySelectorAll(`[data-set-product="${item.id}"] select`).forEach((select) => {
                    select.value = values[select.dataset.attribute] || '';
                });
            });
            enhanceOptions();
            announce();
            update();
        }).fail((xhr, status) => {
            if (request === current && status !== 'abort') fail(xhr.responseJSON?.data?.message);
        }).always(() => {
            if (request !== current) return;
            request = null;
            root.setAttribute('aria-busy', 'false');
            controls(false);
        });
    };

    root.addEventListener('change', (event) => {
        if (!event.target.matches('[data-attribute]') || controlsLocked || !config) return;
        pendingPayload = null;
        announce();
        update();
        const card = event.target.closest('[data-set-product]');
        if (nativeForm && Number(card.dataset.setProduct) === config.base_id) {
            syncing = true;
            const values = saved.get(config.base_id);
            nativeForm.querySelectorAll('select[name^="attribute_"]').forEach((select) => {
                if (select.value !== (values[select.name] || '')) $(select).val(values[select.name] || '').trigger('change');
            });
            syncing = false;
        }
    });

    if (nativeForm) $(nativeForm).on('woocommerce_variation_has_changed.ravessaSets', () => {
        if (!config || syncing || controlsLocked) return;
        const values = nativeSelection();
        content.querySelectorAll(`[data-set-product="${config.base_id}"] select`).forEach((select) => { select.value = values[select.dataset.attribute] || ''; });
        pendingPayload = null;
        update();
    });

    const focusProduct = (card) => {
        if (!card) return;
        const selects = Array.from(card.querySelectorAll('select'));
        const select = selects.find((control) => !control.value) || selects[0];
        const field = select?.closest('[data-set-option]');
        const target = field?.querySelector('[data-set-pill][aria-pressed="true"]:not(:disabled):not([hidden])') || field?.querySelector('[data-set-pill]:not(:disabled):not([hidden])') || (select && !select.hidden ? select : card.querySelector('h3 a'));
        target.focus({ preventScroll: true });
        scrollTo(field || card);
    };

    const add = () => {
        if (!expanded || busy || !config || needsRefresh) return;
        if (selection.length !== config.items.length) {
            guided = true;
            update();
            focusProduct(content.querySelector('[data-set-product][data-complete="false"]'));
            return;
        }
        busy = true;
        controls(true);
        retry.hidden = true;
        announce();
        update();
        const payload = pendingPayload || {
            action: 'ravessa_add_product_set', product_id: config.base_id, set_id: config.set.id,
            nonce: config.nonce, revision: config.revision, request_id: config.request_id, items: JSON.stringify(selection),
        };
        pendingPayload = payload;
        uncertain = false;
        $.ajax({ url: root.dataset.endpoint, type: 'POST', dataType: 'json', timeout: 25000, data: payload })
            .done((response) => {
                if (!response.success) {
                    needsRefresh = true;
                    announce(response.data?.message || 'Nie udało się dodać zestawu. Odśwież wybór poniżej.', true);
                    retry.hidden = false;
                    return;
                }
                config.request_id = response.data.request_id;
                pendingPayload = null;
                announce(response.data.message);
                // Reuse the existing WooCommerce/sidebar flow and its analytics integrations.
                $(document.body).trigger('added_to_cart', [{}, response.data.cart_hash, $(content.querySelector('[data-set-submit]'))]);
                $(document.body).trigger('wc_fragment_refresh');
            }).fail((xhr) => {
                uncertain = !xhr.responseJSON;
                needsRefresh = !uncertain;
                announce(xhr.responseJSON?.data?.message || 'Nie otrzymaliśmy potwierdzenia. Kliknij ponownie — ten sam zestaw nie zostanie dodany drugi raz.', true);
                retry.hidden = uncertain;
                if (!uncertain) pendingPayload = null;
            }).always(() => {
                busy = false;
                controls(uncertain);
                update();
                if (needsRefresh || uncertain) scrollTo(feedback);
            });
    };

    root.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-set-choice]');
        if (choice && !choice.disabled) {
            if (expanded && choice.dataset.setChoice === activeId) {
                collapse();
            } else {
                load(choice.dataset.setChoice);
                panelTitle.focus({ preventScroll: true });
                panel.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
            }
            return;
        }
        if (event.target.closest('[data-set-close]')) { collapse(); return; }
        if (event.target.closest('[data-set-retry]')) load(activeId);
        if (event.target.closest('[data-set-submit]')) add();
        const pill = event.target.closest('[data-set-pill]');
        if (pill && !pill.disabled && !controlsLocked) {
            const select = pill.closest('[data-set-option]').querySelector('select');
            select.value = select.options[Number(pill.dataset.setPill)].value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const jump = event.target.closest('[data-set-jump]');
        if (jump && !jump.disabled) focusProduct(content.querySelector(`[data-set-product="${jump.dataset.setJump}"]`));
        const expand = event.target.closest('[data-set-expand-options]');
        if (expand && !expand.disabled && !controlsLocked) {
            const group = expand.closest('[data-set-option]').querySelector('.ProductSets__pills--visual');
            const expanded = group.dataset.expanded !== 'true';
            group.dataset.expanded = String(expanded);
            expand.setAttribute('aria-expanded', String(expanded));
            expand.textContent = expanded ? 'Zwiń warianty' : `Pokaż wszystkie warianty (${expand.dataset.setExpandOptions})`;
            update();
        }
    });
    root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && expanded && panel.contains(event.target) && !event.target.matches('select') && !controlsLocked) {
            event.preventDefault();
            collapse();
            return;
        }
        const choice = event.target.closest('[data-set-choice]');
        if (!choice || controlsLocked || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = buttons.indexOf(choice);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].focus({ preventScroll: true });
        buttons[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    root.addEventListener('error', (event) => {
        if (event.target.matches?.('.ProductSets__pill--image img, .ProductSets__choiceImage img')) {
            event.target.hidden = true;
            return;
        }
        const slot = event.target.closest?.('[data-set-image]');
        if (!slot || event.target.tagName !== 'IMG') return;
        const item = config?.items.find((product) => product.id === Number(slot.closest('[data-set-product]').dataset.setProduct));
        if (item && !slot.dataset.fallback) {
            slot.dataset.fallback = 'true';
            slot.innerHTML = item.image;
        } else {
            slot.innerHTML = '<span class="ProductSets__noImage">Zdjęcie niedostępne</span>';
        }
    }, true);
}
